// TravelStay.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaHotel, FaBed, FaUser, FaUsers, FaCommentDots, FaInfoCircle, FaExternalLinkAlt } from 'react-icons/fa';
import './TravelStay.css';
import hotelImage from '../../images/wedding/hotel.jpg'; // You'll need to add this image

const TravelStay = () => {
    const { t } = useTranslation();

    const handleHotelLinkClick = (e) => {
        window.open('https://www.scandichotels.no/hotell/norge/fagernes/scandic-valdres', '_blank');
    };

    return (
        <section className="travel-section">
            <div className="travel-container">
                <div className="travel-content">
                    <h2 className="travel-title">{t('travel.title')}</h2>

                    <div className="travel-details">
                        <p className="travel-info"><FaInfoCircle className="icon" /> {t('travel.guestsPay')}</p>

                        <div className="hotel-info">
                            <p className="hotel-reservation"><FaHotel className="icon" /> {t('travel.roomsReserved')}</p>
                            <p className="room-price"><FaUser className="icon" /> <FaBed className="icon" /> {t('travel.singleRoom')}</p>
                            <p className="room-price"><FaUsers className="icon" /> <FaBed className="icon" /> {t('travel.doubleRoom')}</p>
                            <p className="booking-instruction"><FaCommentDots className="icon" /> {t('travel.bookingInstruction')}</p>
                        </div>

                        <div className="hotel-link-container">
                            <p className="hotel-link-intro"><FaInfoCircle className="icon" /> {t('travel.hotelInfo')}</p>
                            <a href="#" className="hotel-link" onClick={handleHotelLinkClick}>
                                <FaExternalLinkAlt className="icon" /> {t('travel.hotelLink')}
                            </a>
                        </div>
                    </div>
                </div>

                <div className="travel-image">
                    <img src={hotelImage} alt={t('travel.imageAlt')} />
                </div>
            </div>
        </section>
    );
};

export default TravelStay;